import cn from "classnames";
import style from "./style.module.css";

const RATING_LABELS = {
  ineffective: "Ineffective",
  minimallyEffective: "Minimally Effective",
  effective: "Effective",
  highlyEffective: "Highly Effective",
  exceptional: "Exceptional",
} as const;

export function AssessmentRating({ title = "Rating", className }: { title?: string; className?: string }) {
  return (
    <section className={cn(style.container, className)}>
      <h3 className={style.title}>{title}</h3>
      <ol className={style.options}>
        {Object.values(RATING_LABELS).map((label) => (
          <li key={label} className={style.option}>
            {label}
          </li>
        ))}
      </ol>
    </section>
  );
}
